import React from 'react';
import { Container, Typography, Box } from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh', // Enables scrolling
        backgroundColor: '#f9f9f9',
        overflowY: 'auto',
        py: 4,
        textAlign: 'justify'
      }}
    >
      <Container maxWidth="lg">
        {/* Title */}

    <img src='/images/image 6.png' alt='' className='w-35' />

        <Box textAlign="center" mb={5}>
          <Typography variant="h4" fontWeight="bold" mt={2}>
            Privacy Policy
          </Typography>
        </Box>

        {/* Introduction */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Introduction
        </Typography>
        <Typography paragraph>
          Welcome to <strong>Empathy Centered</strong>, an app designed to connect job seekers with businesses offering job opportunities. Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you use Empathy Centered.
        </Typography>

        {/* 1. Information We Collect */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          1. Information We Collect
        </Typography>
        <Typography fontWeight="bold" mt={2}>Personal Information:</Typography>
        
          When you register as a job seeker or business, we collect personal information such as your name, email address, phone number, and any other details you provide during the registration process.
For job seekers, this may also include profile photos, resume information, work experience, education, and skills.
For businesses, this may include company name, contact details, and specific job listing information like job descriptions, requirements, and application instructions.
        

        <Typography fontWeight="bold" mt={2}>Location Data:</Typography>
        <Typography paragraph>
        We may collect your location with your permission for features such as attendance tracking and location-based job opportunities.
        </Typography>

        <Typography fontWeight="bold" mt={2}>Authentication Information:</Typography>
        <Typography paragraph>
      We collect authentication data like your name, email address, and profile photo to create and manage your account securely.
        </Typography>

        <Typography fontWeight="bold" mt={2}>Usage Data:</Typography>
        <Typography paragraph>
        We collect information about how you interact with the app, including device information, IP address, and browsing behavior.
        </Typography>

        {/* 2. How We Use Your Information */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          2. How We Use Your Information
        </Typography>
 
          <Typography fontWeight="bold" mt={2}>To Provide Services:</Typography> We use your information to facilitate connections between job seekers and businesses, including displaying job listings to job seekers and sharing applicant profiles with businesses.
        <Typography fontWeight="bold" mt={2}>For Location-Based Services:</Typography>Location data may be used to mark attendance and ensure the accuracy of location-specific features.
         <Typography fontWeight="bold" mt={2}>To Improve Our Services:</Typography> We analyze usage data to enhance the app’s functionality and user experience.
         <Typography fontWeight="bold" mt={2}>Communication:</Typography> We may use your contact information to send notifications, updates, or other communications related to our services.
         <Typography fontWeight="bold" mt={2}>Marketing and Promotions:</Typography>With your consent, we may use your information to send promotional content or marketing messages.
        <Typography fontWeight="bold" mt={2}>Legal Compliance:</Typography> We may use or disclose your information to comply with legal obligations, protect our rights, or prevent fraud.
  

        {/* 3. Sharing Your Information */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          3. Sharing Your Information
        </Typography>
         <Typography fontWeight="bold" mt={2}>With Businesses:</Typography> Job seekers’ profiles may be shared with businesses when they apply for a job.
Businesses’ job listings are visible to registered job seekers.
           <Typography fontWeight="bold" mt={2}>Third-Party Providers:</Typography>We may share your information with third-party service providers assisting us in operating LinkEase, such as hosting services, analytics providers, and customer support.
         <Typography fontWeight="bold" mt={2}>Legal Requirements:</Typography>  Your information may be disclosed if required by law or if necessary to comply with legal processes or protect our rights.
     

        {/* 4. Data Security */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          4. Data Security
        </Typography>
        <Typography paragraph>
        We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, so we cannot guarantee absolute security.
        </Typography>

        {/* 5. Your Choices */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          5. Your Choices
        </Typography>
    
           <Typography fontWeight="bold" mt={2}>Profile Visibility:</Typography>  Job seekers can manage the visibility of their profiles. Businesses can control the details shared in job listings.
          <Typography fontWeight="bold" mt={2}>Account Deletion:</Typography> You can delete your Empathy Centered account at any time through the app’s data deletion functionality. When you initiate account deletion, your profile and associated data will be removed from our active databases.
Please note that some information may be retained for legal or operational purposes as permitted by applicable laws.
Please note that some information may be retained for legal or operational purposes as permitted by applicable laws.
          <Typography fontWeight="bold" mt={2}>Marketing Preferences:</Typography>You can opt out of receiving marketing or promotional messages at any time by updating your preferences in the app.
     

        {/* 6. Children’s Privacy */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          6. Children’s Privacy
        </Typography>
        <Typography paragraph>
          Empathy Centered  is not intended for use by individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us, and we will take appropriate steps to delete it.
        </Typography>

        {/* 7. Background Services */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          7. Background Services
        </Typography>Empathy Centered may run background services to notify users about marking themselves as active or performing specific actions. These notifications are essential to improve user engagement and app functionality.
        <Typography fontWeight="bold" mt={2}>Data Collected in Background:</Typography>
        <Typography paragraph>
       The app may collect data such as user activity status, device information, and notification interactions while running in the background
        </Typography>
        <Typography fontWeight="bold" mt={2}>Purpose:</Typography>
        <Typography paragraph>
          These background services are used solely to notify users about marking themselves active, sending timely reminders, or improving the overall functionality of the app.
        </Typography>
        <Typography fontWeight="bold" mt={2}>User Consent:</Typography>
        <Typography paragraph>
         By using the app, you agree to the use of such background services. You can manage notification settings within the app or through your device settings.
        </Typography>
        <Typography fontWeight="bold" mt={2}>Opt-Out Option:</Typography>
        <Typography paragraph>
         If you do not wish to receive these notifications or allow background activity, you can disable this functionality through the app settings or by uninstalling the app.
        </Typography>

        {/* 8. Contact Us */}
        <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
          8. Contact Us
        </Typography>
        <Typography paragraph>
       If you have any questions or concerns about this Privacy Policy, our data practices, or the data deletion process, please contact us at:
        </Typography>
        <Typography>
          <strong>Email:</strong> healthcare@empathycenteredstaffing.com
         
        </Typography>

        <Typography>
             <strong>Contact:</strong> (512) 993-6283
        </Typography>

        {/* Agreement */}
        {/* <Typography mt={3}>
          By using <strong>Empathy Centered</strong>, you agree to the terms of this Privacy Policy.
        </Typography>
        <Typography mt={1}>
          <strong>Last Updated:</strong> 01/07/2025
        </Typography> */}
      </Container>
    </Box>
  );
}
